import React from "react";

export interface ButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    label: string;
}

export const SubmitButton: React.FC<ButtonProps> = ({
    label,
    type = "submit",
    className,
    ...buttonProps
}) => {
    return (
        <button
            {...buttonProps}
            className={[
                "button",
                "button--medium",
                "button--primary-light",
                "button-submit",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
            type={type}
        >
            <div className="button__text">{label}</div>
        </button>
    );
};

export const SecondaryButton: React.FC<ButtonProps> = ({
    label,
    type = "button",
    className,
    ...buttonProps
}) => {
    return (
        <button
            {...buttonProps}
            className={[
                "button",
                "button--medium",
                "button--secondary",
                "button-submit",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
            type={type}
        >
            <div className="button__text">{label}</div>
        </button>
    );
};

